import { useEffect, useMemo, useState } from "react";
import BottomSheet from "../BottomSheet/BottomSheet";
import { AdminStatsCard } from "./AdminStatsCard";
import { WalletCard } from "./WalletCard";
import useIsMobile from "../../hooks/useIsMobile";
import ModalContainer from "../Modals/CustomModal/Modal";
import { ErrorPaymentCard, SuccessPaymentCard } from "../BuyPowerWorkFlow/PaymentStatusCard";
import { usePowerPurchaseStore } from "../../store/buyPowerStore";
import { getSavedState } from "../../services/localStorage";
import BuyPowerFlow from "../BuyPowerWorkFlow/BuyPowerFlow";
import FundWalletWorkFlow from "../FundWalletWorkFlow/FundWalletWorkFlow";
import FundWalletSuccessStep from "../FundWalletWorkFlow/SuccessStep";
import SuccessStep from "../BuyPowerWorkFlow/SuccessStep";
import { getReportSummary, getWalletBalance } from "../../services/selfService";
import { toast } from "react-toastify";
import { useFundWalletStore } from "../../store/fundWallet";

const DashboardActionCards = () => {
  const isAdmin = true;
  const [showFundWalletPopup, setShowFundWalletPopup] = useState(false);
  const [showBuyPowerModal, setShowBuyPowerModal] = useState(false);
  const user = getSavedState("EMSUser");
   const {   resetFlow, refetchKey, } = usePowerPurchaseStore();
  const {resetFlow: resetFundWalletFlow, saveWalletBalance} = useFundWalletStore();
  const isMobile = useIsMobile();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFundWalletSuccessModal, setShowFundWalletSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [walletBalance, setWalletBalance] = useState(0);
  const [reportSummary, setReportSummary] = useState<any>(null);

  const fetchWalletBalance = async () => {
    setLoading(true);
    try {
      const [reportResponse, walletResponse] = await Promise.all([getReportSummary(), getWalletBalance()]);

      if (reportResponse.data && reportResponse.data.isSuccessful) {
        setReportSummary(reportResponse.data.data);
      }
      if (walletResponse.data && walletResponse.data.isSuccessful) {
        setWalletBalance(walletResponse.data.data);
        saveWalletBalance(walletResponse.data.data);


      }
    } catch (error) {
      toast.error("Error fetching wallet balance or report summary:");
    } finally {
      setLoading(false);
    }
    // setWalletBalance(response.data.balance);
  };

  const handleCloseBuyPowerModal = () => {
    resetFlow();
    setShowBuyPowerModal(false);
  };

  const handleCloseFundWalletModal = () => {
    resetFundWalletFlow();
    setShowFundWalletPopup(false);
  };

  useEffect(() => {
    fetchWalletBalance();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refetchKey]);

  const adminStats = useMemo(() => {
    return [
      { label: "Total power purchased", value: reportSummary?.totalUnitsVended || 0 },
      { label: "Total transactions", value: reportSummary?.totalTransactions || 0 },
      { label: "Pending transactions", value: reportSummary?.totalPendingTransactions || 0 },
    ];
  }, [reportSummary]);

  return (
    <>
      <div className="w-full   mx-auto flex flex-col  lg:flex-row  gap-7">
        <div className=" w-full  lg:w-1/2">
          <WalletCard
            balance={walletBalance}
            onFundWallet={() => setShowFundWalletPopup(true)}
            onBuyPower={isAdmin ? () => setShowBuyPowerModal(true) : undefined}
            isAdmin={isAdmin}
            loading={loading}
          />
        </div>

        <div className="w-full lg:w-1/2">
          <AdminStatsCard stats={adminStats} />
        </div>
      </div>

      {!isMobile && (
        <>
          <ModalContainer
            showModal={showBuyPowerModal}
            setShowModal={setShowBuyPowerModal}
            showGradient={true}
            width={600}
            className="hidden md:block"
            key={showBuyPowerModal ? "open" : "closed"}
          >
            <BuyPowerFlow
              meterNumber={user?.meterNumber || "------------"}
              meterName={user?.fullName ? `${user.fullName} ` : "--------"}
              address={user?.address || "----------"}
              phoneNumber={user?.phoneNumber || "----------"}
              onClose={handleCloseBuyPowerModal}
              onPaymentSuccess={() => {
                setShowBuyPowerModal(false);
                setShowSuccessModal(true);
                setShowErrorModal(false);
              }}
              onPaymentError={() => {
                setShowBuyPowerModal(false);
                setShowSuccessModal(false);
                setShowErrorModal(true);
                // Optionally, show an error modal or toast here
              }}
              isAdmin={isAdmin}
            />
          </ModalContainer>

          {/*Buy Power Success Modal - separate */}
          <ModalContainer
            showModal={showSuccessModal}
            showGradient
            variant="success"
            setShowModal={setShowSuccessModal}
            width={600}
          >
            <SuccessStep title="Transaction Successful" onClose={() => setShowSuccessModal(false)} />
             
          </ModalContainer>

          {/*  Error Modal - separate */}
          <ModalContainer
            showModal={showErrorModal}
            showGradient
            variant="error"
            setShowModal={setShowErrorModal}
            width={600}
          >
            <ErrorPaymentCard
              title="Error processing payment"
              message="We couldn't process your payment."
              primaryButtonText="Try again"
              secondaryButtonText="Close"
              onPrimaryClick={() => console.log("retry")}
              onSecondaryClick={() => console.log("close")}
              onClose={() => console.log("close")}
            />
          </ModalContainer>

          {/* Fund Wallet Modal */}
          <ModalContainer
            width={600}
            showGradient={true}
            showModal={showFundWalletPopup}
            setShowModal={setShowFundWalletPopup}
            className="hidden md:block"
            key={showFundWalletPopup ? "open" : "closed"}
          >
            <FundWalletWorkFlow
              onClose={handleCloseFundWalletModal}
              onPaymentSuccess={() => {
                setShowFundWalletPopup(false);
                setShowFundWalletSuccessModal(true);
                setShowErrorModal(false);
              }}
              onPaymentError={() => {
                setShowFundWalletPopup(false);
                setShowFundWalletSuccessModal(false);
                setShowErrorModal(true);
                // Optionally, show an error modal or toast here
              }}
            />
          </ModalContainer>

          {/* Fund Wallet Success Modal */}
          <ModalContainer
            width={600}
            showGradient={true}
            showModal={showFundWalletSuccessModal}
            setShowModal={setShowFundWalletSuccessModal}
            className="hidden md:block"
          >
            <FundWalletSuccessStep title="Funding Successful" onClose={() => setShowFundWalletSuccessModal(false)} />
          </ModalContainer>
        </>
      )}

      {isMobile && (
        <>
          <BottomSheet
            title={""}
            openBottomSheet={showBuyPowerModal}
            setOpenBottomSheet={setShowBuyPowerModal}
            onCloseAction={() => {
              setShowBuyPowerModal(false);
            }}
            showGradient
            variant="success"
            key={showBuyPowerModal ? "open" : "closed"}
          >
            <BuyPowerFlow
              meterNumber={user?.meterNumber || "01263737893"}
              meterName={user?.fullName ? `${user.fullName} ` : "--------"}
              address={user?.address || "--------"}
              phoneNumber={user?.phoneNumber || "--------"}
              onClose={handleCloseBuyPowerModal}
              onPaymentSuccess={() => {
                setShowBuyPowerModal(false);
                setShowSuccessModal(true);
              }}
              onPaymentError={() => {
                setShowBuyPowerModal(false);
                setShowSuccessModal(false);
                setShowErrorModal(true);
              }}
              isAdmin={isAdmin}
            />
          </BottomSheet>

          {/* Success Modal - separate  */}
          <BottomSheet
            title={""}
            openBottomSheet={showSuccessModal}
            setOpenBottomSheet={setShowSuccessModal}
            onCloseAction={() => {
              setShowSuccessModal(false);
            }}
            showGradient
            variant="success"
          >
            <SuccessPaymentCard
              title="Transaction Successful"
              message=""
              primaryButtonText="Close"
              secondaryButtonText="Try again"
              onPrimaryClick={() => setShowSuccessModal(false)}
              onClose={() => setShowSuccessModal(false)}
              alertBox={{
                title: "Error processing payment",
                message: "We couldn't process your payment.",
                linkHref: "https://google.com",
                linkText: "contact us support@avitechng.com",
              }}
            />
          </BottomSheet>

          {/* // Error Modal - separate */}
          <BottomSheet
            title={""}
            openBottomSheet={showErrorModal}
            setOpenBottomSheet={setShowErrorModal}
            onCloseAction={() => {
              setShowErrorModal(false);
            }}
            showGradient
            variant="error"
          >
            <ErrorPaymentCard
              title="Error processing payment"
              message="We couldn't process your payment."
              primaryButtonText="Try again"
              secondaryButtonText="Close"
              onPrimaryClick={() => console.log("retry")}
              onSecondaryClick={() => console.log("close")}
              onClose={() => console.log("close")}
            />
          </BottomSheet>

          {/* Fund Wallet Modal mobile */}
          <BottomSheet
            title={""}
            openBottomSheet={showFundWalletPopup}
            setOpenBottomSheet={setShowFundWalletPopup}
            onCloseAction={() => {
              setShowFundWalletPopup(false);
            }}
            showGradient
            variant="success"
            key={showFundWalletPopup ? "open" : "closed"}
          >
            <FundWalletWorkFlow
              onClose={handleCloseFundWalletModal}
              onPaymentSuccess={() => {
                setShowFundWalletPopup(false);
                setShowFundWalletSuccessModal(true);
                setShowErrorModal(false);
              }}
              onPaymentError={() => {
                setShowFundWalletPopup(false);
                setShowFundWalletSuccessModal(false);
                setShowErrorModal(true);
                // Optionally, show an error modal or toast here
              }}
            />
          </BottomSheet>

          {/* Fund Wallet Success Modal */}
          <BottomSheet
            title={""}
            openBottomSheet={showFundWalletSuccessModal}
            setOpenBottomSheet={setShowFundWalletSuccessModal}
            onCloseAction={() => {
              setShowFundWalletSuccessModal(false);
            }}
            showGradient
            variant="success"
          >
            <FundWalletSuccessStep
              title="Funding successful"
              message=""
              primaryButtonText="Close"
              secondaryButtonText="Try again"
              onPrimaryClick={() => setShowFundWalletSuccessModal(false)}
              onClose={() => setShowFundWalletSuccessModal(false)}
            />
          </BottomSheet>
        </>
      )}
    </>
  );
};

export default DashboardActionCards;
